import {Panel} from "primereact/panel";
import {Fieldset} from "primereact/fieldset";
import React, {useContext, useEffect, useRef, useState} from "react";
import {AuthContext} from "../App";
import {UserService} from "../services/UserService";
import {Toast} from "primereact/toast";
import SpotifyApps from "./SpotifyApps";
import SpotifyUsers from "./SpotifyUsers";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";

export default function SpotifyConnection({spotifyApps, setSpotifyApps, spotifyUsers, setSpotifyUsers, spotifyAppOptions, setSpotifyAppOptions}) {
    const auth = useContext(AuthContext);

    const toast = useRef(null);
    const userservice = new UserService();
    const [connectURL, setConnectURL] = useState("");


    function connectSpotifyAccount(spotifyuser_id) {
        //const spotis = new SpotiService();

        userservice.connectSpotifyUser(spotifyuser_id, auth.getAccessToken()).then((resp) => {
            if (resp.status === 200) {
                resp.json().then((data) => {
                    setConnectURL(data);
                })
                // toast.current.show({summary:'Connecting Spotify Account ... status 200', severity: 'info'})
            } else {
                toast.current.show({summary:'Connecting Spotify Account ... status ' + resp.status, severity: 'warning'})
            }
        })
        // data.id ... used for feedback
    }

    // TODO next
    //  <Dialog visible={appDialog} style={{ width: '450px' }} header="Spotify App (Developer Mode)" modal className="p-fluid" onHide={hideDialog}>
    //         <SpotifyUserForm onSaveUser={addNewToUsers} newUser={newUser} />
    //     </Dialog>
    function openNewTab(url){
        let win = window.open(url, '_blank');
        win.focus();
    }

    function closeConnectDia(){
        setConnectURL("");
    }

    return (
        <div>
            <Toast ref={toast}/>
            <Panel header="Spotify App Key" toggleable collapsed={false}>

                <Fieldset className={"p-0"}  className={"p-0"}legend={"How to create your own"}>
                    <div className="card mb-4">
                        If you want to create your own Spotify App Key, you can follow these steps:
                        <ul>
                            <li>Go to: https://developer.spotify.com/
                            <Button size="small" icon="pi pi-external-link" text onClick={() => openNewTab("https://developer.spotify.com/")}/>
                            and login with your spotify account</li>
                            <li>Go to dashboard</li>
                            <li>Create app</li>
                            <li>App name: call it playlist.laramon or BTS Playlist Gen, anything that helps you or others identifying who they gave access to (the name of the app will be shown, when your spotify users give access to the app).</li>
                            <li>In Redirect URI add: https://playlist.laramon.ch/callback </li>
                            <li>App description you can fill in what you want and website is optional</li>
                            <li>Select Web-`API</li>
                            <li>Create app - That's it</li>
                        </ul>
                        You now have a Spotify App Key (client_id and client_secret) that you can use to get data and save playlists to spotify using the API.
                    </div>
                </Fieldset>
                <Fieldset className={"p-0"}  className={"p-0"} legend={"Your Spotify App Keys"}>
                    <div className="card mb-4">
                        If you have a key, you can expand it in the list below and give friends access to your App Key.
                    </div>
                    <SpotifyApps spotifyApps={spotifyApps} setSpotifyApps={setSpotifyApps} />
                </Fieldset>
            </Panel>
            <Panel header="Spotify Users" toggleable collapsed={false}>

                <Fieldset className={"p-0"} legend={"Add your spotify users here"}>
                    <div className="card mb-4">
                        If you have your own App Key:
                        <ul>
                            <li>You have to add the e-mail addresses of the spotify users to your development app</li>
                            <li>To do so go to the Spotify Developer Platform Dashboard
                                <Button size="small" icon="pi pi-external-link" text onClick={() => openNewTab("https://developer.spotify.com/dashboard")}/>,
                                click your App.</li>
                            <li>Next to Basic Information is the Tab User Management where you can add all your emails.</li>
                        </ul>
                        If you do not want to create your own App Key:
                        <ul>
                            <li>Maybe you have a friend who already has one and lets you use the App Key.</li>
                            <li>You will have to share the email address of your account/s!</li>
                            <li>The person who adds you to their app, knows where their app users are from (country level). They will also be able to see some metrics of how often the app is used.</li>
                        </ul>
                    </div>
                    <Dialog visible={connectURL !== ""} onHide={closeConnectDia} header="Spotify Authorization">
                        <div style={{maxWidth: "300px"}}>
                            This will open the authorization page of Spotify. It is easiest if you are already logged in spotify with the account you want to connect to! Close this window to cancel.
                        </div>
                        <a href={connectURL} className="p-button font-bold">Connect</a>
                    </Dialog>
                    <SpotifyUsers spotifyUsers={spotifyUsers}
                                  setSpotifyUsers={setSpotifyUsers}
                                  connectSpotifyAccount={connectSpotifyAccount}
                                  spotifyAppOptions={spotifyAppOptions}/>
                </Fieldset>
            </Panel>
        </div>
    )
}